// @flow
export { default as getIcon } from './get-icon';
export { default as getContactHref } from './get-contact-href';
